import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from './CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.ov(parentContext.yc(Key_instance));
        }
        this.rv_1 = parentContext.gm(this);
      }
      mc() {
        return this.rv_1;
      }
      sv() {
        return this.rv_1;
      }
      tv() {
        return super.tv();
      }
      uv(value) {
      }
      vv(cause, handled) {
      }
      wv() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      xv(state) {
        if (state instanceof CompletedExceptionally()) {
          this.vv(state.yv_1, state.aw());
        } else {
          this.uv(state);
        }
      }
      oc(result) {
        var state = this.bw(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.cw(state);
      }
      cw(state) {
        return this.dw(state);
      }
      ew(exception) {
        handleCoroutineException(this.rv_1, exception);
      }
      fw() {
        var tmp0_elvis_lhs = get_coroutineName(this.rv_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.fw();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.fw();
      }
      gw(start, receiver, block) {
        start.jw(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation(), CoroutineScope()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
